import axios from 'axios'

const API_ENDPOINT = 'admin'
const FORMS_LIST_ENDPOINT = API_ENDPOINT + '/forms_list'
const FORMS_UPDATE_ENDPOINT = API_ENDPOINT + '/forms'
const ADMIN_USERS_LIST_ENDPOINT = API_ENDPOINT + '/admin_users_list'
const LANDING_CONFIG_ENDPOINT = API_ENDPOINT + '/landing_config_list'
const LANDING_CONFIG_CREATE_ENDPOINT = API_ENDPOINT + '/landing_config_create'
const LANDING_CONFIG_UPDATE_ENDPOINT = API_ENDPOINT + '/landing_config'
const LANDING_CONFIG_DELETE_ENDPOINT = API_ENDPOINT + '/landing_config'
const ADMIN_FRONTEND_USERS_LIST_ENDPOINT =
    API_ENDPOINT + '/frontend_users_list'
const ADMIN_USERS_CREATE_ENDPOINT = API_ENDPOINT + '/user'
const ADMIN_USERS_UPDATE_ENDPOINT = API_ENDPOINT + '/user'
const ADMIN_USERS_DELETE_ENDPOINT = API_ENDPOINT + '/user'
const ISSUE_PROFORMA_ENDPOINT = API_ENDPOINT + '/proforma'
const ISSUE_INVOICE_ENDPOINT = API_ENDPOINT + '/invoice'

export default {
    getList(params) {
        return axios.get(FORMS_LIST_ENDPOINT, {
            params: params,
        })
    },

    updateForm(id, sections) {
        return axios.put(FORMS_UPDATE_ENDPOINT + '/' + id, { sections })
    },

    getLandingSlides() {
        return axios.get(LANDING_CONFIG_ENDPOINT)
    },

    createConfig(config) {
        return axios.post(LANDING_CONFIG_CREATE_ENDPOINT, config)
    },

    updateConfig(id, config) {
        return axios.put(LANDING_CONFIG_UPDATE_ENDPOINT + '/' + id, config)
    },

    deleteConfig(id) {
        return axios.delete(LANDING_CONFIG_DELETE_ENDPOINT + '/' + id)
    },

    getAdminUserList(params) {
        return axios.get(ADMIN_USERS_LIST_ENDPOINT, {
            params: params,
        })
    },

    getFrontendUserList(params) {
        return axios.get(ADMIN_FRONTEND_USERS_LIST_ENDPOINT, {
            params: params,
        })
    },

    saveUser(user) {
        if (user.id) {
            return axios.put(ADMIN_USERS_UPDATE_ENDPOINT + '/' + user.id, user)
        }
        return axios.post(ADMIN_USERS_CREATE_ENDPOINT, user)
    },

    deleteUser(userId) {
        return axios.delete(ADMIN_USERS_DELETE_ENDPOINT + '/' + userId)
    },

    issueInvoice(formId, proforma) {
        if (proforma) {
            return axios.get(ISSUE_PROFORMA_ENDPOINT + '/' + formId)
        } else {
            return axios.get(ISSUE_INVOICE_ENDPOINT + '/' + formId)
        }
    },
}
